import { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation } from '@react-router';
import { iframeUrlFromVideoUrl } from './utils';
import type { VideoMimeType } from './video.types';

interface Args
  extends Readonly<{
    url: string;
    mimeType: string;
  }> {}

export const useWelcomeVideoController = (args: Args) => {
  const { url, mimeType } = args;
  const [open, setOpen] = useState<boolean>(false);
  const location = useLocation();
  const viewerUrl = useMemo(() => iframeUrlFromVideoUrl(url, mimeType as VideoMimeType), [url, mimeType]);

  const handleOpenClick = useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  const handleCloseClick = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return {
    open,
    handleOpenClick,
    handleCloseClick,
    viewerUrl,
  };
};
